import type { IResponse, LoginInfo } from '../interface';
import { fetch } from '../request';
import { INVITE_CODE, SESSION_REF, SESSION_SOURCE } from '~/constants/config';

export interface IRegisterOrLoginExtraParams {
  source?: string;
  link_code?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

export function getChannel() {
  const route = useRoute();
  const link_code = sessionGetItem(INVITE_CODE) || undefined; // 邀请码注册
  const source = route.query?.from || sessionGetItem(SESSION_SOURCE) || undefined; // 第三方来源注册
  const utm_source = route.query?.utm_source as string;
  const utm_medium = route.query?.utm_medium as string;
  const utm_campaign = route.query?.utm_campaign as string;
  const utm_content = route.query?.utm_content as string;
  const utm_term = (route.query?.utm_term || sessionGetItem(SESSION_REF)) as string; // 第三渠道
  const keyword_search = route.query?.keyword_search as string;
  const gclid = (route.query?.gclid ||
    route.query?.qhclickid ||
    route.query?.bd_vid ||
    route.query?.msclkid) as string;

  return {
    source,
    link_code,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
    keyword_search,
    gclid,
  };
}

export function withRegisterOrLoginExtraParams<T>(config: T) {
  const channel = getChannel();
  const route = useRoute();

  return {
    ...config,
    ...channel,
    ...redirectQueryPPT(route.query?.redirect as string),
  };
}

export function withRegisterOrLoginChannelForUs<T>(config: T) {
  const channel = getChannel();

  return {
    ...config,
    ...channel,
  };
}

export interface IWechatOfficialAccountTicket {
  expired_in: number;
  ticket: string;
  ticket_id: string;
  url: string;
}

export const getWechatOfficialAccountTicket = () => {
  return fetch<IResponse<IWechatOfficialAccountTicket>>(
    '/open_login/wechat/official_account_ticket/',
    {
      method: 'GET',
    }
  );
};

// 0 失败，1 成功 2 进行中
export enum IScanStatus {
  FAIL = 0,
  SUCCESS = 1,
  PENDING = 2,
}

export interface IWechatOfficialAccountScanStatus {
  status: IScanStatus;
  action: 'login' | 'register'; // login 登录，register 注册
  login_data: LoginInfo[];
}

interface IGetWechatOfficialAccountScanStatusConfig extends IRegisterOrLoginExtraParams {
  ticket_id: string;
}
export const getWechatOfficialAccountScanStatus = (
  config: IGetWechatOfficialAccountScanStatusConfig
) => {
  return fetch<IResponse<IWechatOfficialAccountScanStatus>>(
    '/open_login/wechat/official_account_scan_status/',
    {
      method: 'GET',
      params: withRegisterOrLoginExtraParams({
        ticket_id: config.ticket_id,
      }),
    }
  );
};

export interface IWechatOfficialAccountCreateConfig extends IRegisterOrLoginExtraParams {
  mobile: string;
  sms_code: string;
  ticket_id: string;
}
export const postWechatOfficialAccountCreate = (config: IWechatOfficialAccountCreateConfig) => {
  return fetch<IResponse<LoginInfo[]>>('/open_login/wechat/official_account_create/', {
    method: 'POST',
    body: withRegisterOrLoginExtraParams(config),
  });
};
